export default __webpack_public_path__ + "static/media/custom-payment.ad9af427.png";